import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-easysuite-loader',
  templateUrl: './easysuite-loader.component.html',
  styleUrls: ['./easysuite-loader.component.css']
})

// This component is used to display a loading GIF when processing is taking longer
export class EasysuiteLoaderComponent implements OnInit {
  @Input() GUI_themeID: number;
  loaderGifUrl: string;

  constructor() { }

  ngOnInit(): void {
    this.loaderGifUrl = `assets/easysuite/${this.GUI_themeID}/loader_gif.gif`;
  }

}
